const state = {
    changelogOpen: false,
    settings: [],
    logs: [],
    typeOptions: [],
    settingModal: {
        isOpen: false,
        data: {
            name: '',
            type: null,
            enabled: true,
        },
        errors: {},
    },
    errors: {},
}
export default state
